module.exports = __webpack_public_path__ + "static/media/e59.712d6bbe.png";